class MobileNavPanels extends HTMLElement {
  constructor() {
    super();
    this.currentLevel = 0;
    this.panelHistory = [];
  }

  connectedCallback() {
    this.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-panel-target]');
      if (trigger) {
        e.preventDefault();
        this.navigateToPanel(trigger.dataset.panelTarget);
      }
      
      const backButton = e.target.closest('[data-panel-back]');
      if (backButton) {
        e.preventDefault();
        this.navigateBack();
      }
    });

    this.querySelectorAll('.mobile-nav-panel').forEach((panel) => {
      if (panel.classList.contains('mobile-nav-panel--main')) {
        panel.classList.add('is-active');
        panel.style.transform = 'translateX(0)';
      } else {
        panel.style.transform = 'translateX(100%)';
      }
    });
  }

  navigateToPanel(panelId) {
    const targetPanel = this.querySelector(`[data-panel-id="${panelId}"]`);
    const currentActivePanel = this.querySelector('.mobile-nav-panel.is-active');

    if (!targetPanel || !currentActivePanel) return;

    this.panelHistory.push(currentActivePanel);
    currentActivePanel.classList.remove('is-active');
    currentActivePanel.style.transform = 'translateX(-100%)';

    setTimeout(() => {
      targetPanel.classList.add('is-active');
      targetPanel.style.transform = 'translateX(0)';
    }, 50);

    this.currentLevel++;
    this.dataset.navLevel = this.currentLevel;
  }

  navigateBack() {
    if (this.panelHistory.length === 0) return;

    const currentActivePanel = this.querySelector('.mobile-nav-panel.is-active');
    const previousPanel = this.panelHistory.pop();
    if (!currentActivePanel || !previousPanel) return;

    currentActivePanel.classList.remove('is-active');
    currentActivePanel.style.transform = 'translateX(100%)';

    setTimeout(() => {
      previousPanel.classList.add('is-active');
      previousPanel.style.transform = 'translateX(0)';
    }, 50);

    this.currentLevel--;
    this.dataset.navLevel = this.currentLevel;
  }
}

customElements.define('mobile-nav-panels', MobileNavPanels);
